import EBrasil from '@/components/icons/EBrasil.vue';

export const categories = [
    {
        title: 'categories.news',
        color: 'news',
        textColor: 'tw-text-news',
        backgroundColor: 'tw-bg-news',
        foregroundColor: 'tw-text-white',
        value: 'news',
        wordpressId: 1,
        showInNews: true,
        showInSearch: true,
        showInNotifications: true,
        toCategoryPage: {
            name: 'News',
            params: { category: 'news' },
        },
    },
    // buzz
    {
        title: 'categories.buzz',
        color: 'buzz',
        textColor: 'tw-text-buzz',
        backgroundColor: 'tw-bg-buzz',
        foregroundColor: 'tw-text-white',
        value: 'buzz',
        wordpressId: 10,
        showInNews: true,
        showInSearch: true,
        showInNotifications: true,
        toCategoryPage: {
            name: 'News',
            params: { category: 'buzz' },
        },
    },
    // life
    {
        title: 'categories.life',
        color: 'life',
        textColor: 'tw-text-life',
        backgroundColor: 'tw-bg-life',
        foregroundColor: 'tw-text-white',
        value: 'life',
        wordpressId: 11,
        showInNews: true,
        showInSearch: true,
        showInNotifications: true,
        toCategoryPage: {
            name: 'News',
            params: { category: 'life' },
        },
    },
    // sports
    {
        title: 'categories.sports',
        color: 'sports',
        textColor: 'tw-text-sports',
        backgroundColor: 'tw-bg-sports',
        foregroundColor: 'tw-text-white',
        value: 'sports',
        wordpressId: 12,
        showInNews: true,
        showInSearch: true,
        showInNotifications: true,
        toCategoryPage: {
            name: 'News',
            params: { category: 'sports' },
        },
    },
    // motor
    {
        title: 'categories.motor24h',
        color: 'motor',
        textColor: 'tw-text-motor',
        backgroundColor: 'tw-bg-motor',
        foregroundColor: 'tw-text-white',
        value: 'motor24h',
        wordpressId: 13,
        showInNews: false,
        showInSearch: false,
        showInNotifications: false,
        toCategoryPage: {
            name: 'News',
            params: { category: 'motor24h' },
        },
    },
    // ebrasil
    {
        title: 'categories.ebrasil',
        color: 'ebrasil',
        textColor: 'tw-text-ebrasil',
        backgroundColor: 'tw-bg-ebrasil',
        foregroundColor: 'tw-text-white',
        value: 'ebrasil',
        icon: markRaw(EBrasil),
        wordpressId: 14,
        showInNews: true,
        showInSearch: true,
        showInNotifications: true,
        toCategoryPage: {
            name: 'News',
            params: { category: 'ebrasil' },
        },
    },
    // opinion
    {
        title: 'categories.opinion',
        color: 'opinion',
        textColor: 'tw-text-opinion',
        backgroundColor: 'tw-bg-opinion',
        foregroundColor: 'tw-text-white',
        value: 'opinion',
        wordpressId: 7,
        showInNews: true,
        showInSearch: true,
        showInNotifications: true,
        toCategoryPage: {
            name: 'News',
            params: { category: 'opinion' },
        },
    },

    // tv24
    {
        title: 'categories.tv24h',
        color: 'tv',
        textColor: 'tw-text-tv',
        backgroundColor: 'tw-bg-tv',
        foregroundColor: 'tw-text-white',
        value: 'tv24h',
        wordpressId: 7,
        showInNews: false,
        showInSearch: true,
        showInNotifications: false,
        toCategoryPage: {
            name: 'TV24h',
        },
    },
];

// TypeScript type for category
export type Category = {
    title: string;
    color: string;
    textColor: string;
    wordpressId: number;
    showInNews: boolean;
    showInNotifications: boolean;
    toPostPage?: string;
    toCategoryPage?: {
        name: string;
        params?: Record<string, any>;
    };
    icon?: any;
    backgroundColor: string;
    foregroundColor: string;
    value: string;
};

export default categories;
